// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".count-container--countContainer--3B8vnn0s {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin: auto 0 16px 0;\n}\n.count-container--countContainer--3B8vnn0s .count-container--numItems--3g38V7Hr {\n  background-color: #f5fbfc;\n  border-radius: 15px 0 0 15px;\n  color: #3f3f3f;\n  height: 30px;\n  padding-right: 20px;\n}\n.count-container--countContainer--3B8vnn0s .count-container--containerLabel--dMH1MhGQ {\n  font-weight: bold;\n  padding-left: 20px;\n}\n.count-container--countContainer--3B8vnn0s .count-container--numItems--3g38V7Hr span {\n  position: relative;\n  line-height: 30px;\n}\n", ""]);
// Exports
exports.locals = {
	"countContainer": "count-container--countContainer--3B8vnn0s",
	"numItems": "count-container--numItems--3g38V7Hr",
	"containerLabel": "count-container--containerLabel--dMH1MhGQ"
};
module.exports = exports;
